import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { getPeople } from '../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

let cachedParams = null

function* LOAD({ payload: { params } }) {
  const companySelect = localStorage.getItem('app.settings.company')
  // const companySelect = useSelector(s => s.companySelect);
  cachedParams = params
  // const companySelect = yield select(getCompanySelect)
  // const companySelect = useSelector(s => s.companySelect);

  if (!companySelect || companySelect === -1) {
    return
  }

  yield put(request(getPeople(companySelect, params), actions.LOAD))
}

function* REFRESH() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD), takeEvery('company/save', REFRESH), takeEvery('people/create/success', REFRESH), takeEvery('people/destroy/success', REFRESH)])
}
